'use client';

import styled from 'styled-components';

import { useVirtualKeyboard } from '@zoomit/primitives';
import { theme } from '@zoomit/zoomit-ds';

import { useScrollDirection } from '../../hooks/useScrollDirection';
import type { DisplayModule } from '../../types/modules';
import AdvertisingParser from './AdvertisingParser';

type Props = {
  module: DisplayModule;
  isPositionFixed?: boolean;
  className?: string;
};

const AdvertisingStickyMobile = (props: Props) => {
  const { module, isPositionFixed = true } = props;

  const { showContent } = useScrollDirection();

  const { isKeyboardOpen } = useVirtualKeyboard();

  return (
    <MobileBottomAdsContainer
      show={showContent && !isKeyboardOpen}
      isPositionFixed={isPositionFixed}
      {...props}
    >
      <AdvertisingParser module={module} closeButtonKind="on-display" />
    </MobileBottomAdsContainer>
  );
};

export default AdvertisingStickyMobile;

const MobileBottomAdsContainer = styled.div<{ show: boolean; isPositionFixed: boolean }>`
  position: ${({ isPositionFixed }) => (isPositionFixed ? 'fixed' : 'relative')};
  left: 0;
  bottom: 0;
  z-index: 5;
  width: 100%;
  padding-bottom: ${({ isPositionFixed }) => (isPositionFixed ? 'env(safe-area-inset-bottom)' : '')};
  display: ${({ show }) => (show ? 'block' : 'none')};

  &::after {
    display: ${({ isPositionFixed, show }) => (show && isPositionFixed ? 'block' : 'none')};
    content: '';
    position: absolute;
    width: 100%;
    height: 48px;
    background: var(${theme.background2});
  }
`;
